import 'styles/Header.less'
import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import moment from 'moment'
import classNames from 'classnames'
import Menu from 'components/Utils/Menu'
import assets from 'modules/assets'
import * as actions from 'actions'

class HeaderGallery extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menuState: false,
      isNavigateGallery: false,
      headerIsHidden: false
    }

    this.SHARE_LINK = {
      '2019': {
        'japan': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2019/japan',
      },
      '2018': {
        'japan1': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2018/japan1',
        'usa1': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2018/usa1',
        'japan2': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2018/japan2',
        'usa2': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2018/usa2'
      },
      '2017': {
        'bali': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2017/bali',
        'chiba': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2017/chiba',
        'danube': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2017/danube',
        'france': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2017/france'
      },
      '2016': {
        'bali': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2016/bali',
        'chiba': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2016/chiba',
        'danube': 'https://www.facebook.com/sharer/sharer.php?u=gallery.gakkoproject.com/gallery/2016/danube'
      }
    }

    this.DOWNLOAD_LINK = {
      '2019': {
        'japan': 'https://drive.google.com/drive/u/4/folders/17TqGlreaHenIgJjsls-b80h8LjyikKtK',
      },
      '2018': {
        'japan1': 'https://drive.google.com/drive/folders/1oNAjdzYMdBqurgoekHuJGICPpUQ246fC',
        'usa1': 'https://drive.google.com/drive/folders/1oNAjdzYMdBqurgoekHuJGICPpUQ246fC',
        'japan2': 'https://drive.google.com/drive/folders/1oNAjdzYMdBqurgoekHuJGICPpUQ246fC',
        'usa2': 'https://drive.google.com/drive/folders/1oNAjdzYMdBqurgoekHuJGICPpUQ246fC'
      },
      '2017': {
        'bali': 'https://drive.google.com/open?id=0ByO6zavATklNZlM2NWZSS3VIcVE',
        'chiba': 'https://drive.google.com/open?id=0ByO6zavATklNRzZnSlpkano2dmM',
        'danube': 'https://drive.google.com/open?id=0ByO6zavATklNQ04xOS1HYTNNbnM',
        'france': 'https://drive.google.com/open?id=0ByO6zavATklNTWJfZjBjUVNxNzg'
      },
      '2016': {
        'bali': 'https://drive.google.com/open?id=0ByO6zavATklNaFZJLWs2RGxLMlE',
        'chiba': 'https://drive.google.com/open?id=0ByO6zavATklNaFZJLWs2RGxLMlE',
        'danube': 'https://drive.google.com/open?id=0ByO6zavATklNaFZJLWs2RGxLMlE'
      }
    }

    this.clickShareButton = this.clickShareButton.bind(this)
    this.lastScrollY = 0
    this.currentScrollUp = 0
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      menuState: nextProps.menuState,
      infoCamp2016: nextProps.infoCamp2016,
      alertIsMinimized: nextProps.alertIsMinimized,
      alertIsHidden: nextProps.alertIsHidden,
      isNavigateGallery: nextProps.isNavigateGallery,
      headerIsHidden: nextProps.headerIsHidden
    })
  }
  toggleMenu = () => {
    this.props.dispatch(actions.token.toggleMenu(!this.state.menuState))
  }

  toggleInfo = () => {
    this.props.dispatch(actions.token.infoCamp2016(!this.state.infoCamp2016))
  }

  clickShareButton() {
    let currentCamp = this.props.params.campid
    let url = this.SHARE_LINK[this.props.params.year][currentCamp]
    window.open(url, 'Share on Facebook!', 'left=20,top=20,width=500,height=500,toolbar=1,resizable=0')
    return false
  }

  downloadHover() {
    this.refs.downloadIcon.src = assets('icons/download_red.svg')
  }

  downloadEndHover() {
    this.refs.downloadIcon.src = assets('icons/download_black.svg')
  }

  shareHover() {
    this.refs.shareIcon.src = assets('icons/share_red.svg')
  }

  shareEndHover() {
    this.refs.shareIcon.src = assets('icons/share_black.svg')
  }

  infoHover() {
    this.refs.infoIcon.src = assets('icons/info_red.svg')
  }

  infoEndHover() {
    this.refs.infoIcon.src = assets('icons/info_black.svg')
  }

  handleScroll() {
    const domNode1 = ReactDOM.findDOMNode(this.refs['scroll1'])
    const domNode2 = ReactDOM.findDOMNode(this.refs['scroll2'])
    if (this.lastScrollY < window.scrollY) {
      this.currentScrollUp += (window.scrollY - this.lastScrollY)
      domNode1.style.marginTop = `${-this.currentScrollUp}px`
      domNode2.style.marginTop = `${-this.currentScrollUp}px`
      if (this.currentScrollUp > 50) {
        domNode1.style.opacity = domNode2.style.opacity = 0
      }
    } else {
      domNode1.style.marginTop = `0`
      domNode2.style.marginTop = `0`
      this.currentScrollUp = 0
      domNode1.style.opacity = domNode2.style.opacity = 1
    }

    this.lastScrollY = window.scrollY
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this), false)
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, false)
  }

  render() {
    if (this.state.headerIsHidden) {
      return null
    }
    let currentCamp = '', currentYear = ''
    let campNameMap = {
      'bali': 'Bali',
      'chiba': 'Japan',
      'danube': 'Romania',
      'france': 'France',
      'japan1': 'Japan 1',
      'japan2': 'Japan 2',
      'usa1': 'USA 1',
      'usa2': 'USA 2',
      'japan': 'Japan'
    }
    if (this.props.params.campid) {
      currentCamp = campNameMap[this.props.params.campid]
    }

    let currentYearName = ''
    if (this.props.params.year) {
      currentYearName = `Gakko${this.props.params.year}`
      currentYear = this.props.params.year
    }

    let fixPosition = {
      position: 'fixed',
      top: 0
    }

    if (!this.props.params.year || !this.props.params.campid) {
      return null
    }

    //<a href={this.DOWNLOAD_LINK[this.props.params.campid]} target='_blank'><i className="fa fa-download" aria-hidden="true"></i></a>
    return (
      <div className='header-component header-camp-2016' style={fixPosition}>
        <section className="main-grid">
          <ul className="grid group" style={{'paddingLeft': '25px', 'paddingRight': '25px', 'marginTop': '5px'}}>
            <li className="grid-small">
              <div className='header-menu' style={{'display': 'inline-flex'}} onClick={this.toggleMenu}>
                <span className='header-camp-id' style={{'textTransform': 'capitalize', 'lineHeight': '20px', 'paddingRight': '5px', 'fontSize': '18pt'}}>{currentYearName}</span>
                <i className="fa fa-angle-down" aria-hidden="true"></i>
                <span ref="scroll1" className='header-camp-id opacity-fade-in' style={{'textTransform': 'capitalize', 'lineHeight': '20px', 'paddingRight': '5px', 'fontSize': '18pt', 'marginLeft': '10vw'}}>{currentCamp}</span>
              </div>
            </li>
            <li className="grid-small grid-middle no-display-mobile" style={{'textAlign': 'center'}}>
            </li>
            <div className="camp-2016-header-icons opacity-fade-in" ref="scroll2">
              <a href={this.DOWNLOAD_LINK[currentYear][this.props.params.campid]} target='_blank'><img ref='downloadIcon' src={assets('icons/download_black.svg')} onMouseEnter={this.downloadHover.bind(this)} onMouseLeave={this.downloadEndHover.bind(this)}/></a>
              <img ref='shareIcon' src={assets('icons/share_black.svg')} onClick={this.clickShareButton} onMouseEnter={this.shareHover.bind(this)} onMouseLeave={this.shareEndHover.bind(this)}/>
              <img ref='infoIcon' src={assets('icons/info_black.svg')} onClick={this.toggleInfo} onMouseEnter={this.infoHover.bind(this)} onMouseLeave={this.infoEndHover.bind(this)}/>
            </div>
          </ul>
        </section>
      </div>
    )
  }
}
HeaderGallery.contextTypes = {
}
HeaderGallery.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    menuState: state.token.menuState,
    infoCamp2016: state.token.infoCamp2016,
    alertIsMinimized: state.token.alertIsMinimized,
    alertIsHidden: state.token.alertIsHidden,
    isNavigateGallery: state.token.isNavigateGallery,
    headerIsHidden: state.token.headerIsHidden
  }
}

export default connect(mapStateToProps)(HeaderGallery)



// WEBPACK FOOTER //
// ./src/components/Gallery/HeaderGallery.js